<div class="content-block light-control-host" id="template-choice-content">
  @if (loading) {
    <div>
      <h1><svg lucideLoaderCircle class="lucide-spin"></svg> {{ loadingText }}</h1>
    </div>
  } @else if (loadFailed) {
    <div>
      <h1>We couldn't check your connectivity</h1>
      <div class="load-failed-notice margin-top" data-cy="template-choice-load-failed">
        <svg lucideCircleAlert aria-hidden="true"></svg>
        <p>Something went wrong reaching your cloud accounts. Try again, or go back and review the sync pair.</p>
      </div>
      <div class="flex-center-row margin-top">
        <div class="spacer"></div>
        <button type="button" class="arpio-secondary-button" (click)="backButtonClick()">Back</button>
        <button
          type="button"
          class="arpio-button margin-left"
          data-cy="template-choice-retry"
          (click)="retryAccessCheck()"
        >
          Try Again
        </button>
      </div>
    </div>
  } @else {
    @if (isAzure) {
      <h1>Apply your access updates?</h1>
    } @else {
      <h1>Update your access templates?</h1>
    }

    <p class="header-description">
      @if (recoveryOnlyBehind) {
        @if (isAzure) {
          Recovery access is already deployed but is missing newer {{ uiService.productName }} access updates. Creating
          this application is supported but some resource types may not be able to recover until those updates are
          applied.
        } @else {
          Recovery access is already deployed on an older template version. Creating this application with the deployed
          version is supported but some resource types may not be able to recover until it's updated.
        }
      } @else if (isAzure) {
        Access is already deployed but is missing newer {{ uiService.productName }} access updates. Creating this
        application is supported but newer resource types may not be supported.
      } @else {
        Access is already deployed on an older template version. Creating this application with the deployed version is
        supported but newer resource types may not be supported.
      }
    </p>

    <div class="template-choice-cards margin-top">
      <div
        class="template-choice-card light-content-panel"
        [class.selected]="selectedChoice === 'update'"
        data-cy="template-choice-update"
        (click)="selectChoice('update')"
      >
        <!-- The label is the click target and the radio's accessible name, so the whole
        card works by mouse and by keyboard without a custom role. -->
        <label class="card-header">
          <input
            type="radio"
            name="templateChoice"
            value="update"
            class="arpio-radio"
            [checked]="selectedChoice === 'update'"
            (change)="selectChoice('update')"
          />
          @if (isAzure) {
            <h3>Apply updates</h3>
          } @else {
            <h3>Update templates</h3>
          }
          <span class="choice-tag choice-tag--recommended">Recommended</span>
        </label>
        <div class="card-description">
          @if (isAzure) {
            Apply the newer access updates first, then continue. Every resource type
            {{ uiService.productName }} supports becomes available to this application.
          } @else {
            Deploy the current access templates first, then continue. Every resource type
            {{ uiService.productName }} supports becomes available to this application.
          }
        </div>
      </div>

      <div
        class="template-choice-card light-content-panel"
        [class.selected]="selectedChoice === 'existing'"
        data-cy="template-choice-existing"
        (click)="selectChoice('existing')"
      >
        <label class="card-header">
          <input
            type="radio"
            name="templateChoice"
            value="existing"
            class="arpio-radio"
            [checked]="selectedChoice === 'existing'"
            (change)="selectChoice('existing')"
          />
          @if (isAzure) {
            <h3>Use existing access</h3>
          } @else {
            <h3>Use existing templates</h3>
          }
          <span class="choice-tag">Not recommended</span>
        </label>
        <div class="card-description">
          @if (isAzure) {
            Create this application on the access that's already deployed. Resource types that need the newer updates
            won't be available.
          } @else {
            Create this application on the template version that's already deployed. Resource types that need the newer
            template won't be available.
          }
        </div>
      </div>
    </div>

    <div class="flex-center-row margin-top">
      <div class="spacer"></div>
      <button type="button" class="arpio-secondary-button" data-cy="template-choice-back" (click)="backButtonClick()">
        Back
      </button>
      <button
        type="button"
        class="arpio-button margin-left"
        data-cy="template-choice-continue"
        (click)="continueButtonClick()"
      >
        Continue
      </button>
    </div>
  }
</div>
